export const iconGrey31 = '#B1B1B1';
export const iconGrey71 = '#4B4B4B';
export const iconGrey40 = '#999999';
